import * as f from '../../../components/BPMTable/BPMInputs'
import {
    TableFieldDescription,
    DataMapper,
    DataTransformer,
    NullClickStrategy,
    OnlyFilterActionDisplayStrategy,
    DateTimeComponentCreator,
    DateTimeDisplayCreator,
    StatusChipComponentCreator,
    MultilineComponentCreator,
} from '../../../components/BPMTable/TableMapperCreator'
import { DirectTableQueryBuilder } from '../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder'
import { ExportFooterItemCreator } from '../../../components/BPMTable/TableFooterItems'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'

const queries = { tableQueryBuilder: new DirectTableQueryBuilder('allCompanyChangeProcessControls') }

const parseJson = value => (value && typeof value === 'object') ? value : (value ? JSON.parse(value) : null)

const errorCount = ({errors}) => {
    const arr = parseJson(errors)
    return arr ? arr.length : 0
}

const statValue = key => ({stats}) => {
    const s = parseJson(stats)
    return s ? (s[key] ?? '-') : '-'
}

class CMInventoryChangeTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return 'CMInventoryChangeTableCreator'
    }

    getTableCreator = (tableName) => {
        const tableCreator = this.createTableCreator(
            this.constructor.getId(),
            tableName,
            queries,
            new NullClickStrategy(),
            new OnlyFilterActionDisplayStrategy()
        )

        tableCreator.setAdditionalFilters({ first: 30 })
        tableCreator.setInitialSortField('id', 'desc')
        tableCreator.setTableFooterItems([new ExportFooterItemCreator()])

        tableCreator.addDescriptions([
            new TableFieldDescription(
                'id',
                new DataMapper('id'),
                new f.FilterDescription(new f.NullCreator()),
                { label: 'ID' }
            ),
            new TableFieldDescription(
                'state',
                new DataMapper('state'),
                new f.FilterDescription(new f.ProcessControlStateFilter('state')),
                { label: 'State', componentCreator: new StatusChipComponentCreator() }
            ),
            new TableFieldDescription(
                'user',
                new DataMapper('user.enterpriseId'),
                new f.FilterDescription(new f.TextFilter('user')),
                { label: 'User' }
            ),
            new TableFieldDescription(
                'companyChange',
                new DataMapper('companyChange.id'),
                new f.FilterDescription(new f.NullCreator()),
                { label: 'Company Change ID', hideSort: true }
            ),
            new TableFieldDescription(
                'companyChange.submittedAt',
                new DataMapper('companyChange.submittedAt'),
                new f.FilterDescription(new f.NullCreator()),
                { label: 'Submitted At', hideSort: true, componentCreator: new DateTimeComponentCreator(), excelDisplay: new DateTimeDisplayCreator() }
            ),
            new TableFieldDescription(
                'createdAt',
                new DataMapper('createdAt'),
                new f.FilterDescription(new f.PeriodFilter('createdAt')),
                { label: 'Created At', componentCreator: new DateTimeComponentCreator(), excelDisplay: new DateTimeDisplayCreator() }
            ),
            new TableFieldDescription(
                'updatedAt',
                new DataMapper('updatedAt'),
                new f.FilterDescription(new f.PeriodFilter('updatedAt')),
                { label: 'Updated At', componentCreator: new DateTimeComponentCreator(), excelDisplay: new DateTimeDisplayCreator() }
            ),
            new TableFieldDescription(
                'errors',
                new DataMapper('errors'),
                new f.FilterDescription(new f.NullCreator()),
                { label: 'Errors', hideSort: true, transform: new DataTransformer(errorCount) }
            ),
            new TableFieldDescription(
                'stats.rowsParsed',
                new DataMapper('stats'),
                new f.FilterDescription(new f.NullCreator()),
                { label: 'Rows Parsed', hideSort: true, transform: new DataTransformer(statValue('rows_parsed')) }
            ),
            new TableFieldDescription(
                'stats.usersChanged',
                new DataMapper('stats'),
                new f.FilterDescription(new f.NullCreator()),
                { label: 'Users Changed', hideSort: true, transform: new DataTransformer(statValue('users_changed')) }
            ),
            new TableFieldDescription(
                'message',
                new DataMapper('message'),
                new f.FilterDescription(new f.NullCreator()),
                { label: 'Message', onlyForm: true, hideSort: true, componentCreator: new MultilineComponentCreator() }
            ),
        ])

        return tableCreator
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(CMInventoryChangeTableCreator)

export default CMInventoryChangeTableCreator
